import { supabase } from '../supabase/supabaseClient';

export const login = async (email, password) => {
  // 1️⃣ Login dengan Supabase
  const { data, error } = await supabase.auth.signInWithPassword({
    email,
    password,
  });

  if (error) return { error: error.message };
  if (!data.user) return { error: 'User not found' };

  // 2️⃣ Set session Supabase agar bisa restore di incognito / tab baru
  await supabase.auth.setSession(data.session);

  // 3️⃣ Simpan session di localStorage
  localStorage.setItem('sb-session', JSON.stringify(data.session));

  // 4️⃣ Ambil member data dari table 'members'
  const { data: memberData, error: memberError } = await supabase
    .from('members')
    .select('id, member_id, email, is_active, role_id, full_name')
    .eq('auth_id', data.user.id)
    .single();

  if (memberError || !memberData) return { error: 'Member data not found' };
  if (!memberData.is_active) return { error: 'Inactive account' };

  // 5️⃣ Simpan user info di localStorage
  localStorage.setItem('user', JSON.stringify(memberData));

  return { user: memberData };
};

export const logout = async () => {
  try {
    // Logout dari Supabase
    await supabase.auth.signOut();

    // Hapus localStorage
    localStorage.removeItem('sb-session');
    localStorage.removeItem('user');

    return { success: true };
  } catch (error) {
    console.error('Error logout:', error);
    return { success: false, error };
  }
};

export const emailResetPassword = async (email) => {
  try {
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${process.env.REACT_APP_URL}/reset-password`,
    });

    if (error) return { success: false, message: error.message };

    return { success: true };
  } catch (err) {
    return { success: false, message: 'Something went wrong' };
  }
};

export const resetPassword = async (newPassword) => {
  try {
    const { error } = await supabase.auth.updateUser({
      password: newPassword,
    });

    if (error) {
      return { success: false, message: error.message };
    }

    return { success: true };
  } catch (err) {
    return { success: false, message: "Unexpected error occurred" };
  }
};